
import { Component, Prop } from 'vue-property-decorator';
import VWidget from '@/components/VWidget.vue';
import url from '@/lib/url';
import ListBase from '@/lib/listbase';

@Component({
    components: { VWidget }
})
export default class SelectedManufacturer extends ListBase {
    @Prop({ type: String, default: 'daily' }) destinationRouteName!: string;

    get widgetTitle(): string {
        return this.destinationRouteName === 'daily'
            ? 'Daily Sales'
            : 'Despachos AASA';
    }

    get filteredManufacturers() {
        const simaList = this.$store.state.dailyModule?.dailyManufacturers || [];
        return simaList.filter((pro: any) => pro && pro.id != null && pro.id > 0);
    }

    imageSrc(image: string) {
        return url + image;
    }

    selectBrand(pro: any) {
        console.log('Seleccionado fabricante:', pro);
        this.$router.push({
            name: this.destinationRouteName,
            query: { marca: `${pro.id}|${pro.name}` }
        });
    }

    async mounted() {
        await this.$store.dispatch('dailyModule/getAllForSima');
    }
}
